// F-next: narrativa ejecutiva vía ServiciosIA. Este slot reserva la posición
// final para no relayoutear cuando se construya. Hoy renderiza null (no mostrar
// "próximamente" — a gerencia le parece inacabado).
const AiNarrativeSlot = () => null;

export default AiNarrativeSlot;
